const API_URL = import.meta.env.VITE_AUTH_SERVER_URL || 'http://localhost:3001';

/** @param {{ signal?: AbortSignal }} [options] */
export async function fetchArenaLadders({ signal } = {}) {
  const response = await fetch(`${API_URL}/api/rankings/arena`, { signal });
  if (!response.ok) {
    throw new Error(`Arena rankings request failed with status ${response.status}`);
  }

  const payload = await response.json();
  if (!payload || !Array.isArray(payload.ladders)) {
    throw new Error('Arena rankings response is malformed');
  }
  return payload;
}
